<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-divider type="vertical" class="item" />

                <a-radio-group
                    v-model="search.type"
                    button-style="solid"
                    @change="(e) => on_field_change(e.target.value, 'type')"
                    class="item"
                >
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="deposit">首款</a-radio-button>
                    <a-radio-button value="retainage">尾款</a-radio-button>
                </a-radio-group>

                <!-- <a-radio-group
                    v-model="search.audit_status"
                    button-style="solid"
                    @change="(e) => on_field_change(e.target.value, 'audit_status')"
                    class="item"
                >
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="1">处理中</a-radio-button>
                    <a-radio-button value="2">已同意</a-radio-button>
                    <a-radio-button value="3">已拒绝</a-radio-button>
                </a-radio-group> -->
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索单号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-button v-if="search.order_no" style="margin-left:16px;margin-top:16px" @click="on_reset">
                订单号：{{ search.order_no }} <a-icon type="close" />
            </a-button>

            <a-spin tip="加载中" :spinning="loading">
                <div class="items" v-if="loading || data_source.length">
                    <section class="item" v-for="item in data_source" :key="item.transaction_no">
                        <div class="head">
                            <div class="date">
                                <span
                                    v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                ></span>
                            </div>

                            <div class="order-no">
                                流水号：
                                {{ item.transaction_no }}
                            </div>
                        </div>
                        <div class="body">
                            <div class="status">
                                <audit-status :audit_status="item.paid_at ? 2 : 1" />
                            </div>

                            <div class="order">
                                <div class="detail">
                                    <div class="name">
                                        {{ item.order_no }}
                                    </div>

                                    <div class="more" v-if="item.order.trademark">
                                        商标名称：{{item.order.trademark.markName}}，{{item.order.trademark.internationalGroup}}类
                                    </div>

                                    <div class="more" v-else>商标已删除</div>
                                </div>
                            </div>

                            <div class="amount">
                                <div class="type">
                                    {{ item.type_text }}
                                </div>

                                <div class="price">¥{{ item.amount }}</div>
                            </div>

                            <div class="supplier">
                                <div class="corner">收款客户</div>

                                <template v-if="item.supplier">
                                    <div class="name">
                                        {{ item.supplier.contact_name }}
                                        <div class="id">ID：{{ item.supplier_id }}</div>
                                    </div>
                                    <div class="payment">
                                        <div class="payment-type">
                                            {{ item.supplier.payment_type_text }}
                                        </div>
                                        <div class="payment-detail">
                                            <template v-if="item.supplier.payment_no">
                                                <div v-if="item.supplier.payment_type === 'alipay'">
                                                    <small>户名：{{ item.supplier.payment_account }}</small> <br />
                                                    <small>账号：{{ item.supplier.payment_no }}</small>
                                                </div>
                                                <div v-if="item.supplier.payment_type === 'bank'">
                                                    <small>开户行：{{ item.supplier.payment_name }}</small
                                                    ><br /><small>户名：{{ item.supplier.payment_account }}</small
                                                    ><br />
                                                    <small>账号：{{ item.supplier.payment_no }}</small>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <div class="remark">
                                {{ item.remark || "无备注" }}
                            </div>

                            <div class="creater">
                                <a v-if="item.screenshot" :href="item.screenshot" target="_blank">查看付款截图</a>
                            </div>

                            <div class="creater">
                                <div class="name">{{ item.user.name }}</div>
                                <div class="date">申请于：{{ moment(item.created_at * 1000).format("MM-DD HH:mm") }}</div>
                            </div>

                            <div class="action">
                                <a-button size="small" @click="on_approve(item)" :disabled="!!item.paid_at">上传截图</a-button>
                            </div>
                        </div>
                        <div class="foot" v-if="item.failure_msg"><a-icon class="icon" type="info-circle" />{{ item.failure_msg }}</div>
                    </section>
                </div>
            </a-spin>

            <!-- 分页 -->
            <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
                <div></div>
                <a-pagination
                    :disabled="loading"
                    v-model="pagination.current"
                    :total="pagination.total"
                    :page-size.sync="pagination.pageSize"
                    show-size-changer
                    showQuickJumper
                    :pageSizeOptions="['20', '50', '100', '200']"
                    @change="(page, pageSize) => on_pagination_change_common(page, pageSize)"
                    :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
                />
            </div>

            <a-empty :image="simpleImage" v-if="!loading && !data_source.length" style="margin-top: 96px;">
                <a-button @click="load" icon="reload" style="margin-right:24px;">
                    刷新
                </a-button>
                <a-button @click="on_reset" icon="rollback">重置</a-button>
            </a-empty>
        </div>

        <!-- 同意 -->
        <modal_approve type="loan" @close="visible_approve = false" :visible="visible_approve" :record="selected_record" :callback="load" />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import { Empty } from "ant-design-vue";
    import modal_approve from "./modal_approve";

    export default {
        mixins: [common_pagination],
        beforeCreate() {
            this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
        },
        components: { modal_approve },
        data() {
            return {
                path: "/finance/payment",
                data_source: [],
                selected_record: {},
                loading: false,
                visible_approve: false,
                wd: null,
                search: { audit_status: 1, type: "" },
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_finance",
                value: "payment",
            });
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/payment?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            reset_query() {
                let query = this.$route.query;
                this.wd = "wd" in query ? query["wd"] : "";
                this.search.order_no = "order_no" in query ? query["order_no"] : "";
                this.search.audit_status = "audit_status" in query ? query["audit_status"] : "";
                this.search.type = "type" in query ? query["type"] : "";
            },
            on_approve(record) {
                this.selected_record = record;
                this.visible_approve = true;
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

        .items {
            min-height: 200px;
            .item {
                border: 1px solid #e8e8e8;
                margin: 16px;
                border-radius: 5px;
                overflow: hidden;
                min-width: 200px;
                &:hover {
                    box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px 0 #0000000d, 0 12px 48px 16px #00000008;
                }
                .head {
                    padding: 8px 16px;
                    display: flex;
                    align-items: center;
                    background: #f1f1f1;
                    .date {
                        margin-right: 24px;
                        color: #9e9e9e;
                        min-width: 120px;
                    }
                }
                .body {
                    display: flex;
                    .status {
                        min-width: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        font-weight: bold;
                    }
                    .order {
                        display: flex;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        min-width: 250px;

                        .thumb {
                            margin-right: 12px;
                            text-align: center;
                            margin-left: 12px;
                        }
                        .detail {
                            padding: 16px;
                            .name {
                                font-size: 14px;
                                margin-bottom: 4px;
                            }
                            .more {
                                font-size: 12px;
                            }
                            .name-b {
                                font-size: 12px;
                            }
                        }
                    }
                    .amount {
                        padding: 16px;
                        min-width: 200px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .type {
                            border-right: 1px solid #efefef;
                            padding-right: 24px;
                            margin-right: 24px;
                            font-weight: bold;
                        }
                        .price {
                            font-size: 16px;
                            font-weight: bold;
                        }
                        .lirun {
                            font-size: 12px;
                            span {
                                color: red;
                            }
                        }
                    }
                    .supplier {
                        min-width: 240px;
                        padding: 16px;
                        width: 100%;
                        border-right: 1px solid #efefef;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .name {
                            min-width: 80px;
                            .id {
                                font-size: 12px;
                                color: #9e9e9e;
                            }
                        }
                        .corner {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 24px;
                            padding: 0 8px;
                            background: #fafafa;
                            color: #00000073;
                            font-size: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                    .seller-amount {
                        min-width: 130px;
                        padding: 16px;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .corner {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 24px;
                            padding: 0 8px;
                            background: #fafafa;
                            color: #00000073;
                            font-size: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                    .creater {
                        min-width: 150px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .date {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .remark {
                        min-width: 150px;
                        border-right: 1px solid #efefef;
                        padding: 16px;
                    }
                    .action {
                        min-width: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        .ant-btn {
                            &:first-child {
                                margin-bottom: 4px;
                            }
                        }
                    }
                }
                .foot {
                    background: #fffbe6;
                    padding: 4px 16px;
                    font-size: 12px;
                    .icon {
                        margin-right: 8px;
                    }
                }
            }
        }

        .page {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            .tips {
                font-size: 12px;
                color: #9e9e9e;
            }
        }
    }
</style>
